import { LayoutSavitarna } from '@/layouts'

export const routeSavitarna = [
  {
    path: '*',
    redirect: { name: 'home' },
  },
  {
    path: '/closeWindow',
    name: 'closeWindow',
    component: () =>
      import(
        /* webpackChunkName: "closeWindow" */ '@/views/closeWindow/closeWindow.vue'
      ),
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "savlogin" */ '@/views/auth/Login.vue'),
    meta: {
      title: 'Login',
      open: true,
    },
    hidden: true,
  },
  {
    path: '/ipasas',
    name: 'ipasasAuth',
    meta: {
      title: 'iPASAS',
      open: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "ipasasAuth" */ '@/views/auth/IpasasAuth.vue'
      ),
  },
  {
    path: '/',
    name: 'home',
    component: LayoutSavitarna,
    meta: {
      title: 'Pagrindinis',
    },
    children: [
      {
        path: '/home',
        name: 'homepage',
        component: () =>
          import(
            /* webpackChunkName: "homepage" */ '@/views/homepage/Homepage.vue'
          ),
      },
      {
        path: '/new-procuration',
        name: 'savNewProcuration',
        component: () =>
          import(
            /* webpackChunkName: "savNewProcuration" */ '@/views/procuration/NewProcuration.vue'
          ),
        redirect: { name: 'procurationSteps', params: { step: 1 } },
        children: [
          {
            path: 'step/:step/:id?',
            name: 'procurationSteps',
            component: () =>
              import(
                /* webpackChunkName: "procurationSteps" */ '@/views/procuration/ProcurationSteps.vue'
              ),
            meta: {
              title: 'Nauja prokūra',
            },
          },
        ],
      },
      {
        path: '/subdelegate',
        name: 'savSubMandate',
        component: () =>
          import(
            /* webpackChunkName: "savSubMandate" */ '@/views/mandate/SubMandate.vue'
          ),
        redirect: { name: 'subMandateSteps', params: { step: 1 } },
        children: [
          {
            path: 'step/:step/:id?/parent/:parentId?',
            name: 'subMandateSteps',
            component: () =>
              import(
                /* webpackChunkName: "mandateSteps" */ '@/views/mandate/MandateSteps.vue'
              ),
            meta: {
              title: 'Perįgaliojimas',
            },
          },
        ],
      },
      {
        path: '/new-mandate',
        name: 'savNewMandate',
        component: () =>
          import(
            /* webpackChunkName: "savNewMandate" */ '@/views/mandate/NewMandate.vue'
          ),
        redirect: { name: 'mandateSteps', params: { step: 1 } },
        children: [
          {
            path: 'step/:step/:id?',
            name: 'mandateSteps',
            component: () =>
              import(
                /* webpackChunkName: "mandateSteps" */ '@/views/mandate/MandateSteps.vue'
              ),
            meta: {
              title: 'Naujas įgaliojimas',
            },
          },
        ],
      },
      {
        path: '/mandates',
        name: 'savMandates',
        component: () =>
          import(/* webpackChunkName: "savMandates" */ '@/views/savMenu/mandates/Mandates.vue'),
        meta: {
          title: 'Mano įgaliojimai',
        },
      },
      {
        path: '/procurations',
        name: 'savProcurations',
        component: () =>
          import(/* webpackChunkName: "savMandates" */ '@/views/savMenu/procurations/Procurations.vue'),
        meta: {
          title: 'Mano prokūros',
        },
      },
      {
        path: '/procuration/refuse/:id/:view?',
        name: 'savProcurationTerminate',
        component: () =>
          import(/* webpackChunkName: "savProcurationRefuse" */ '@/views/procuration/ProcurationRefuseOrCancellation.vue'),
        meta: {
          title: 'Prokūros atšaukimas',
        },
      },
      {
        path: '/procuration/terminate/:id/:view?',
        name: 'savProcurationRefuse',
        component: () =>
          import(/* webpackChunkName: "savProcurationTerminate" */ '@/views/procuration/ProcurationRefuseOrCancellation.vue'),
        meta: {
          title: 'Prokūros atsisakymas',
        },
      },
      {
        path: '/mandate/refuse/:id/:view?',
        name: 'savMandateRefuse',
        component: () =>
          import(/* webpackChunkName: "savMandateRefuse" */ '@/views/mandate/MandateRefuseOrCancellation.vue'),
        meta: {
          title: 'Įgaliojimo atsisakymas',
        },
      },
      {
        path: '/mandate/terminate/:id/:view?',
        name: 'savMandateTerminate',
        component: () =>
          import(/* webpackChunkName: "savMandateTerminate" */ '@/views/mandate/MandateRefuseOrCancellation.vue'),
        meta: {
          title: 'Įgaliojimo panaikinimas',
        },
      },
      {
        path: '/mandate/:id/:tab?/:returnId?',
        name: 'savMandateView',
        component: () =>
          import(/* webpackChunkName: "savMandateView" */ '@/views/mandate/MandateView.vue'),
        meta: {
          title: 'Įgaliojimo peržiūra',
        },
      },
      {
        path: '/procuration/:id/:tab?',
        name: 'savProcurationView',
        component: () =>
          import(/* webpackChunkName: "savProcurationView" */ '@/views/procuration/ProcurationView.vue'),
        meta: {
          title: 'Prokūros peržiūra',
        },
      },
      {
        path: '/document/view/:id/:productLink?',
        name: 'savDocumentView',
        component: () =>
          import(/* webpackChunkName: "savDocumentView" */ '@/views/mandate/DocumentView.vue'),
        meta: {
          title: 'Dokumento peržiūra',
        },
      },
      {
        path: '/documents',
        name: 'savDocuments',
        component: () =>
          import(/* webpackChunkName: "savDocuments" */ '@/views/savMenu/documents/Documents.vue'),
        meta: {
          title: 'Mano dokumentai',
        },
      },
      {
        path: '/orders',
        name: 'savOrders',
        component: () =>
          import(/* webpackChunkName: "savOrders" */ '@/views/savMenu/orders/Orders.vue'),
        meta: {
          title: 'Išrašų užsakymas',
        },
      },

      {
        path: '/order/view/:id',
        name: 'savOrderView',
        component: () =>
          import(/* webpackChunkName: "savNewOrder" */ '@/views/savMenu/orders/OrderView.vue'),
        meta: {
          title: 'Išrašo peržiūra',
        },
      },
      {
        path: '/order/new',
        name: 'savNewOrder',
        component: () =>
          import(/* webpackChunkName: "savNewOrder" */ '@/views/savMenu/orders/NewOrder.vue'),
        meta: {
          title: 'Išrašų užsakymas',
        },
      },
      {
        path: '/notifications',
        name: 'savNotifications',
        component: () =>
          import(
            /* webpackChunkName: "savNotifications" */ '@/views/savMenu/notifications/Notifications.vue'
          ),
        meta: {
          title: 'Pranešimai',
        },
      },
      //
      {
        path: '/info/:type',
        name: 'savInfoPage',
        component: () =>
          import(
            /* webpackChunkName: "savNotifications" */ '@/views/administration/pages/info'
          ),
        meta: {
          title: 'Pranešimas',
        },
      },
      {
        path: '/404',
        name: 'sav404',
        component: () =>
          import(
            /* webpackChunkName: "savNotifications" */ '@/views/administration/pages/404'
          ),
        meta: {
          title: '404',
        },
      },
      //
      {
        path: '/product/:id',
        name: 'savProduct',
        component: () =>
          import(
            /* webpackChunkName: "savNotifications" */ '@/views/Product.vue'
          ),
        meta: {
          title: '',
        },
      },
    ],
  },
]
